import { Activity, CarFront, LayoutDashboard, Route, ScrollText, ShieldCheck, Users, type LucideIcon } from "lucide-react";

export const ADMIN_ROLE = "admin";

export type NavGroupId = "monitor" | "people" | "team";

export type NavItem = {
  id: string;
  href: string;
  icon: LucideIcon;
  group: NavGroupId;
  phonePrimary?: boolean;
  adminOnly?: boolean;
};

export const NAV_GROUPS: NavGroupId[] = ["monitor", "people", "team"];

export const NAV_ITEMS: NavItem[] = [
  { id: "overview", href: "/", icon: LayoutDashboard, group: "monitor", phonePrimary: true },
  { id: "system", href: "/system", icon: Activity, group: "monitor" },
  { id: "accounts", href: "/accounts", icon: Users, group: "people", phonePrimary: true },
  { id: "convoys", href: "/convoys", icon: CarFront, group: "people", phonePrimary: true },
  { id: "drives", href: "/drives", icon: Route, group: "people", phonePrimary: true },
  { id: "operators", href: "/operators", icon: ShieldCheck, group: "team" },
  { id: "audit", href: "/audit", icon: ScrollText, group: "team" },
];

export function visibleNavItems(role: string | null): NavItem[] {
  return NAV_ITEMS.filter((item) => !item.adminOnly || role === ADMIN_ROLE);
}

export const PHONE_PRIMARY_ORDER = ["overview", "accounts", "convoys", "drives"];

export const PHONE_PRIMARY_ITEMS: NavItem[] = PHONE_PRIMARY_ORDER.map(
  (id) => NAV_ITEMS.find((item) => item.id === id) as NavItem,
);

export const HOME_HREF = "/";

export function isActiveHref(pathname: string, href: string): boolean {
  if (href === "/") return pathname === "/";
  return pathname === href || pathname.startsWith(`${href}/`);
}

export function activeNavItem(pathname: string): NavItem | undefined {
  return NAV_ITEMS.find((item) => isActiveHref(pathname, item.href));
}
